import React, { useEffect, useState } from "react";
import { Row, Col, Button, message, Form, Card, Spin } from "antd";
import { FormProvider, useForm } from "react-hook-form";
import Address from "./components/AddInformation/Address";
import Units from "./components/AddInformation/Units";
import {
  DateField,
  InputField,
  ReactSelectField,
} from "../../../atoms/FormElement";
import dayjs from "dayjs";
import {
  dateFormat,
  datePlaceholderddmmyyFormat,
} from "../../BookingForm/components/utils";
import axios from "../../../../utils/axiosInceptor";
import { addNewSingleUnit } from "../../../../configs/constants";
import { useDispatch, useSelector } from "react-redux";
import { getPropertiesDrop } from "../../Properties/ducks/actions";
import { getSinglePropertyDetail } from "../ducks/actions";
import { convertToTitleCase } from "../../../libs/utils";
import { useApiWithFilters } from "../../../../hooks/search/useApiWithFilters";
import { getBeneficiaries } from "./ducks/actions/getOwner";

var _ = require("lodash");

const AddSingleUnit = (props) => {
  const { onSuccess } = props;
  const dispatch: any = useDispatch();
  const form = useForm();
  const {
    control,
    formState: { errors },
    setValue,
    handleSubmit,
    watch,
    getValues,
    clearErrors
  } = form;
  
  const properties = useSelector(
    (state: any) => state.dashboard.propertiesDrop
  );
  const selectedProperty = watch("propertyName");
  const [isPropertyDetailsFetched, setIsPropertyDetailsFetched] =
    useState(false);
  const [businessUnitId, setBusinessUnitId] = useState("");
  const [businessUnitName, setBusinessUnitName] = useState("");
  const [community, setCommunity] = useState("");
  const [emirates, setEmirates] = useState("");

  const [propertyRefNumber, setPropertyRefNumber] = useState(null);
  const [beneficiariesOptions, setBeneficiariesOptions] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    data: ownersResult,
    loading: isLoadingOwners,
    fetchData: fetchOwners,
  } = useApiWithFilters({
    apiUrl: "/property/owner",
    method: "GET",
    initialParams: { limit: 20000, page: 1 },
  });

  const dataSubmit = async (value) => {
    setIsSubmitting(true);
    let payload = {
      propertyName: value?.propertyName?.label,
      propertyId: value?.propertyName?.value,
      dewaPremiseNumber: value?.DMNumber,
      businessUnitName: businessUnitName,
      businessUnitId: businessUnitId,
      unit: {
        floorNumber: value?.floorNumber,
        unitNumber: value?.unitNumber,
        unitCode: value?.unitCode,
        usagesType: convertToTitleCase(value?.usagesType?.value),
        unitType: convertToTitleCase(value?.unitType?.value),
        unitSubType: value?.unitSubType?.value,
        areaSqft: value?.areaSqft.toString(),
        suiteSize: value?.suiteSize,
        balconySize: value?.balconySize,
      },
      address: {
        addressLine1: value.addressLine1,
        addressLine2: value.addressLine2,
        addressLine3: "",
        country: value.country?.value,
        emirates: value.city?.value || emirates,
        longitude: value.longitude,
        latitude: value.latitude,
        community: community,
      },
      ownerNumber: value?.owner?.ownerNumber || value?.ownerNumber,
      ownerName: value?.owner?.label,
      ownerId: value?.owner?.ownerId,
      beneficiaryId: value?.beneficiary?.value,
      beneficiaryName: value?.beneficiary?.label,
      erpActiveStartDate: value?.effectiveStartDate,
      erpActiveEndDate: value?.effectiveEndDate,
      erpLaName: value?.propertyAdminName,
      erpLaEmail: value?.propertyAdminEmail,
      unitDescription: value?.unitDescription,
    };

    let url = addNewSingleUnit;
    try {
      const response = await axios.post(url, payload);
      const { data } = response;
      if (data?.code === 201) {
        message.success("Unit Added Successfully");
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      message.error(error.response?.data?.error || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    dispatch(getPropertiesDrop());
    fetchOwners();

    // Set default dates
    const startOfMonth = dayjs().startOf("month");
    const endDate = startOfMonth.add(5, "year");
    setValue("effectiveStartDate", startOfMonth);
    setValue("effectiveEndDate", endDate);
  }, []);

  const getBeneficiariesOption = async (ownerId) => {
    if (!ownerId) {
      setBeneficiariesOptions([]);
      return;
    }
    try {
      const data = await getBeneficiaries(ownerId);
      if (data?.length > 0) {
        let result = _.map(data, (item) => ({
          value: item?.beneficiaryId,
          label: item?.beneficiaryName,
        }));
        setBeneficiariesOptions(result);
      } else {
        setBeneficiariesOptions([]);
      }
    } catch (error) {
      setBeneficiariesOptions([]);
    }
  };

  const handleOwnerChange = (selectedOwner) => {
    setValue("owner", selectedOwner);
    setValue("beneficiary", null);
    if (selectedOwner?.ownerId) {
      getBeneficiariesOption(selectedOwner.ownerId);
    } else {
      setBeneficiariesOptions([]);
    }
  };

  useEffect(() => {
    const fetchPropertyDetails = async () => {
      if (selectedProperty?.value) {
        try {
          const propertyDetails = await getPropertyById(selectedProperty.value);
          setValue("propertyAdminName", propertyDetails?.erpLaName || "");
          setValue("propertyAdminEmail", propertyDetails?.erpLaEmail || "");
          setValue(
            "propertyReferenceNumber",
            propertyDetails?.propertyReferenceNumber
          );

          setValue("addressLine1", propertyDetails?.address.addressLine1 || "");
          setValue(
            "addressLine2",
            propertyDetails?.address?.addressLine2 || ""
          );

          setValue("longitude", propertyDetails?.address?.longitude || "");
          setValue("latitude", propertyDetails?.address?.latitude || "");

          setValue("country", {
            value: propertyDetails?.address?.country || "",
            label:
              propertyDetails?.address?.countryName ||
              propertyDetails?.address?.country ||
              "",
          });

          setValue("city", {
            value: propertyDetails?.address?.emirates || "",
            label:
              propertyDetails?.address?.emiratesName ||
              propertyDetails?.address?.emirates ||
              "",
          });

          setIsPropertyDetailsFetched(true);
          setBusinessUnitId(propertyDetails?.businessUnitId || "");
          setBusinessUnitName(propertyDetails?.businessUnitName || "");
          setCommunity(propertyDetails?.address?.community || "");
          setEmirates(propertyDetails?.address?.emirates || "");
          setPropertyRefNumber(propertyDetails?.propertyReferenceNumber);
          clearErrors(["propertyAdminName", "propertyAdminEmail", "propertyReferenceNumber", "addressLine1", "addressLine2", "longitude", "latitude", "country", "city"]);
        } catch (error) {
          console.log("facing issue fetch product detail", error);
        }
      }
    };

    fetchPropertyDetails();
  }, [selectedProperty?.value, setValue]);

  const getPropertyById = async (propertyId) => {
    try {
      const detail = await getSinglePropertyDetail(propertyId);
      return detail;
    } catch (error) {
      console.log("facing issue fetch product detail", error);
      throw error; // rethrow so useEffect can catch
    }
  };

  return (
    <FormProvider {...form}>
    <Spin spinning={isSubmitting} tip="Submitting...">
    <Form
      layout="vertical"
      className="bf-main"
      onFinish={handleSubmit(dataSubmit)}
    >
      <Card
        title="Property Details"
        bordered={false}
        style={{
          marginBottom: 16,
          boxShadow: "none",
          border: "1px solid #f0f0f0",
          paddingBottom: "0px",
        }}
        bodyStyle={{ paddingBottom: "0px" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <ReactSelectField
              isRequired={true}
              label="Property"
              fieldname="propertyName"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Select Property",
              }}
              selectOption={properties}
              rules={{ required: "Please select at least one property" }}
              validate={errors.propertyName && "error"}
              validMessage={errors.propertyName && errors.propertyName.message}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={false}
              label="Property Admin Name"
              fieldname="propertyAdminName"
              control={control}
              classes={""}
              initValue=""
              iProps={{
                placeholder: "Enter Property Admin Name",
                readOnly: isPropertyDetailsFetched,
                className: "",
              }}
              disabled={isPropertyDetailsFetched}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={false}
              label="Property Admin Email"
              fieldname="propertyAdminEmail"
              control={control}
              classes={""}
              initValue=""
              iProps={{
                placeholder: "Enter Property Admin Email",
                readOnly: isPropertyDetailsFetched,
                className: "",
              }}
              disabled={isPropertyDetailsFetched}
            />
          </Col>

          <Col span={8}>
            <InputField
              isRequired={true}
              label="Property Reference Number"
              fieldname="propertyReferenceNumber"
              control={control}
              initValue=""
              iProps={{
                placeholder: "Property Reference Number",
              }}
              rules={{ required: "Property reference number is required" }}
              validate={errors.propertyReferenceNumber && "error"}
              validMessage={
                errors.propertyReferenceNumber &&
                errors.propertyReferenceNumber.message
              }
              disabled={isPropertyDetailsFetched}
            />
          </Col>
          <Address
            colSpan={8}
            control={control}
            errors={errors}
            setValue={setValue}
            noEdit={false}
            isUnitPopUp={true}
            isPropertyDetailsFetched={isPropertyDetailsFetched}
          />
        </Row>
      </Card>

      <Card
        title="Unit Details"
        bordered={false}
        style={{
          marginBottom: 16,
          boxShadow: "none",
          border: "1px solid #f0f0f0",
          paddingBottom: "0px",
        }}
        bodyStyle={{ paddingBottom: "0px" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <DateField
              control={control}
              isRequired={true}
              setValue={setValue}
              label="Start Date"
              fieldname="effectiveStartDate"
              validate={errors.effectiveStartDate && "error"}
              rules={{
                required: "Select Start Date",
              }}
              onChange={(date) => {
                if (date) {
                  setValue("effectiveStartDate", dayjs(date));
                  // Auto-update end date to start date + 5 years if end date is not manually changed
                  const newEndDate = dayjs(date).add(5, "year");
                  const currentEndDate = getValues("effectiveEndDate");
                  if (!currentEndDate || dayjs(currentEndDate).isSame(dayjs().startOf("month").add(5, "year"))) {
                    setValue("effectiveEndDate", newEndDate);
                  }
                } else {
                  setValue("effectiveStartDate", "");
                }
              }}
              iProps={{
                format: datePlaceholderddmmyyFormat,
                placeholder: datePlaceholderddmmyyFormat,
                // suffixIcon: <Calendar />,
                disabledDate: (date) => {
                  const endDate = getValues("effectiveEndDate");
                  return endDate ? date.isAfter(dayjs(endDate), "day") : false;
                },
              }}
              valueGot={dateFormat(dayjs().startOf("month"))}
              validMessage={
                errors.effectiveStartDate && errors.effectiveStartDate.message
              }
            />
          </Col>

          <Col span={8}>
            <DateField
              control={control}
              isRequired={true}
              setValue={setValue}
              label="End Date"
              fieldname="effectiveEndDate"
              validate={errors.effectiveEndDate && "error"}
              rules={{
                required: "Select End Date",
              }}
              onChange={(date) => {
                if (date) {
                  setValue("effectiveEndDate", dayjs(date));
                } else {
                  setValue("effectiveEndDate", "");
                }
              }}
              iProps={{
                format: datePlaceholderddmmyyFormat,
                placeholder: datePlaceholderddmmyyFormat,
                // suffixIcon: <Calendar />,
                disabledDate: (date) => {
                  const startDate = getValues("effectiveStartDate");
                  return startDate
                    ? date.isBefore(dayjs(startDate), "day")
                    : false;
                },
              }}
              valueGot={dateFormat(dayjs().startOf("month").add(5, "year"))}
              validMessage={
                errors.effectiveEndDate && errors.effectiveEndDate.message
              }
            />
          </Col>
          <Units
            colSpan={8}
            control={control}
            errors={errors}
            setValue={setValue}
            watch={watch}
            noEdit={false}
            propertyRefNumber={propertyRefNumber}
          />
          <Col span={8}>
            <InputField
              isRequired={true}
              label="Dewa Premise Number"
              fieldname="DMNumber"
              control={control}
              classes=""
              initValue=""
              iProps={{
                placeholder: "Dewa Premise Number",
                readOnly: false,
                className: "",
              }}
              rules={{ required: "Enter Dewa Premise Number" }}
              validate={errors.DMNumber && "error"}
              validMessage={errors.DMNumber && errors.DMNumber.message}
            />
          </Col>
        </Row>
      </Card>

      <Card
        title="Ownership"
        bordered={false}
        style={{
          marginBottom: 16,
          boxShadow: "none",
          border: "1px solid #f0f0f0",
          paddingBottom: "0px",
        }}
        bodyStyle={{ paddingBottom: "0px" }}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <ReactSelectField
              isRequired={false}
              label="Owner"
              fieldname="owner"
              control={control}
              initValue=""
              setValue={setValue}
              iProps={{
                placeholder: "Select Owner",
              }}
              selectOption={_.map(ownersResult?.result?.data || [], (item) => ({
                value: item?.name,
                label: item?.name,
                ownerId: item?.ownerId,
                ownerNumber: item?.number,
                ownerNationality: item?.nationality,
              }))}
              onChange={handleOwnerChange}
            />
          </Col>
          <Col span={8}>
            <ReactSelectField
              isRequired={false}
              label="Beneficiary"
              fieldname="beneficiary"
              control={control}
              initValue=""
              setValue={setValue}
              iProps={{
                placeholder: "Select Beneficiary",
              }}
              selectOption={beneficiariesOptions}
            />
          </Col>
        </Row>
      </Card>

      <Col span={24}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "30px",
          }}
        >
          <Button
            htmlType="submit"
            type="primary"
            size="large"
            className="csv_publish"
            loading={isSubmitting}
            disabled={isSubmitting}
          >
            Submit
          </Button>
        </div>
      </Col>
      {/* </Row> */}
    </Form>
    </Spin>
    </FormProvider>
  );
};

export default AddSingleUnit;
